import { Action, AnyAction } from 'redux';
import { ThunkAction, ThunkDispatch } from 'redux-thunk';

import { AppState } from './store';
import { RailsConstants } from 'utilities/initialize_centre';
import { UserData } from './auth';

export interface ThunkDispatchProps {
  dispatch: ThunkDispatch<AppState, {}, AnyAction>;
}

// API

export interface StatusMessage {
  content: string;
  type: StatusMessageType;
}

export enum StatusMessageType {
  Error = 1,
  Warning = 2,
  Information = 3,
  Success = 4,
}

export interface CollectionMeta {
  unfilteredCount: number;
  filteredCount: number;
  // The total number of items in the (filtered) collection.
  total_count: number;
}

/**
 * Describes the shape of the JSON response from API endpoints.
 */
export interface ApiResponse<D, M = {}, E = {}> {
  code: number;
  payload: Payload<D, M>;
  messages: StatusMessage[];
  errors: E;
}

/**
 * Describes the shape of the payload in the JSON response.
 */
export interface Payload<D, M = {}> {
  data: D;
  meta: M;
}

export interface GrapeApiError {
  error: string;
}

/**
 * Describes the shape of the response data from endpoints that return entity collections.
 */
export interface CollectionData<D> {
  // The items that should be displayed.
  items: D[];
}

/**
 * Describes the shape of the response data from endpoints that return single entities.
 */
export interface Data<D> {
  // The items that should be displayed.
  data: D;
}

export type ApiPromise<D, M = {}, E = {}> = Promise<ApiResponse<D, M, E>>;

/**
 * Describes the query parameters accepted by API endpoints that return entity collections.
 */
// TODO: modified for CareCorners
export interface CollectionQueryParams {
  page: {
    // The number of items to be skipped over.
    offset: number;
    // // The maximum number of items to be returned.
    limit: number;
  };
  // The search query to be applied on the collection.
  search: string;
  // The filters to be applied on the collection.
  filter: { [key: string]: any };
  // The name of the column to sort the collection by.
  sortBy: string;
  // The sorting direction.
  order: 'asc' | 'desc';
}

declare module 'redux' {
  // Overload to add thunk support to Redux's dispatch() function.
  export interface Dispatch<A extends Action = AnyAction> {
    // tslint:disable-next-line
    <R, E>(thunk: ThunkAction<R, AppState, E, AnyAction>): R;
  }
}

// Globals

declare global {
  interface Window {
    __DATA__: {
      user: UserData;
    };
    __CONSTANTS__: RailsConstants;
    NDI?: any;
  }
}
